import React from 'react'
import {Container, Form, Row, Col} from 'react-bootstrap'
import Navbar from 'components/category/navbar'
import {useHistory} from 'react-router-dom'
import UpdateAkun from './update_akun'
import './style.css'

export default function Akun() {
    const history = useHistory()
    const handleClick = () => {
        history.push('/ber_akun')
    }
    return (
        <>
            <Navbar />
            <Container className="akun-page-berberkah">
            <div className="title">
                <img onClick={handleClick} src="asset/dashboard/icons/arr-left.svg" alt="left" />
                <h5>Akun Saya</h5>
            </div>
                <div className="akun-content-berberkah">
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md="2">
                            Nama
                        </Form.Label>
                        <Col md={10}>
                            <Form.Control type="text" placeholder="Nama" />
                            <small>(Contoh : Umar Sabirin)</small>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column md="2">
                            Nomor Hp
                        </Form.Label>
                        <Col md={10}>
                            <Form.Control type="tel" placeholder="Nomor Hp" />
                            <small>(Contoh : 0812-3456-7890)</small>
                        </Col>
                    </Form.Group>
                    <UpdateAkun />
                </div>
            </Container>
        </>
    )
}
